<template>
  <div>
    <div class="right-title">
      <span>对公转账管理</span>
    </div>
    <div class="content-box">
      <div class="search-box">
        <el-input
          class="search"
          type="text"
          prepend="iconbianji1"
          placeholder="请输入机构名称"
          v-model="search"
        >
        </el-input>
        <el-button @click="keyWord" type="primary" style="margin-left: 10px;">搜索</el-button>
      </div>
      <div class="tab-box">
        <el-table
                ref="multipleTable"
                :data="list"
                tooltip-effect="dark"
                style="width: 100%;height: 100%"
                :header-cell-style="{background: '#f2f3f5',
    color: '#000;'}"
        >
          <el-table-column
                  prop="create_time"
                  label="日期"
                  align="center"
                  id="hao"
          >
          </el-table-column>
          <el-table-column
                  prop="organization_name"
                  label="相关机构"
                  align="center"
          >
          </el-table-column>
          <el-table-column
                  prop="money"
                  label="金额"
                  align="center"
                  >
          </el-table-column>
          <el-table-column
            prop="type"
            label="说明"
            align="center"
          >
            <template slot-scope="scope">
              <span >{{scope.row.type === 1?'咸豆充值':'VIP购买'}}</span>
            </template>
          </el-table-column>
          <el-table-column
                  prop="chakan"
                  label="查看详情"
                  align="center"
                  show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="hal-cursor" @click="handleDetail(scope.row.id)">查看详情</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div v-show="scope.row.status === 0">
                <el-button
                        size="mini"
                        type="primary"
                        @click="handleDaoZhang(scope.row.id)">到账</el-button>
                <el-button
                        size="mini"
                        type="primary"
                        @click="handleJuJue(scope.row.id)">拒绝</el-button>
              </div>
              <div v-show="scope.row.status === 2">
                <el-button type="text" style="color: red;" @click="handleJuJueYuanYin(scope.row.id)">查看拒绝原因</el-button>
              </div>
              <div v-show="scope.row.status === 1">
                <el-button type="text" style="color: green;" disabled>已确认到账</el-button>
              </div>
            </template>
          </el-table-column>

        </el-table>
        <div class="page-box">
          <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page.sync="page.pageNum"
                  :page-size="page.pageSize"
                  layout="prev, pager, next, jumper"
                  :total="page.pageTotal">
          </el-pagination>
        </div>
      </div>
      <!--      详情弹框     -->
      <el-dialog
              title=""
              :visible.sync="dialogVisible"
              width="30%"
              :before-close="handleClose"
              append-to-body>
        <p class="pXq">转账详情</p>
        <p class="Tp1"><span class="s1">账户名称：</span><span class="s2">{{dataTwo.organization_name}}</span></p>
        <p class="Tp1"><span class="s1">开户行：</span><span class="s2">{{dataTwo.blank_address}}</span></p>
        <p class="Tp1"><span class="s1">银行卡号：</span><span class="s2">{{dataTwo.card_num}}</span></p>
        <p class="Tp1" style="color: #f20000"><span class="s1">金额：</span><span class="s2">{{dataTwo.money}}</span></p>
      </el-dialog>

    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "jgPay",
    data() {
      return {
        search:'',
        tableData: [],
        multipleSelection: [], //  选中的
        dialogVisible: false, //  详情弹框
        dataTwo:[], //    详情弹框数据
        page:{
          pageNum:1,
          pageSize:10,
          pageTotal:1
        }
      }
    },
    computed: {
      list(){
        let _list = JSON.parse(JSON.stringify(this.tableData))
        _list.map(item => {
          // 时间
          item.create_time = this.$tools.ZHDate(new Date(item.create_time * 1000),1)

        })
        return _list
      },
      user(){
        return this.$store.state.user
      }
    },
    created() {
      this.$emit('setType', 2, 0)
      this.zhuanZhangList()
    },
    methods: {

      toDetail(id){
        console.log(id)
        // this.$router.push({
        //   path:'/home/hxrAdmin/hxrBiaoDanDetail/' + id
        // })
      },
      // 对公转账列表
      zhuanZhangList() {
        const loading = this.$loading({
          target: this.$refs.listBox,
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        if(this.$route.query.pageNum){
          this.page.pageNum = Number(this.$route.query.pageNum)
        }else {
          this.page.pageNum = 1
        }
        if (this.$route.query.key) {
          this.search = this.$route.query.key
        } else {
          this.search = ''
        }
        this.$api.apiContent.jgDuiGongZhuanZhang({
          search: this.search,
          page:this.page.pageNum,
          pageSize:this.page.pageSize,
          admin_id:this.user.id
        }).then(res => {
           loading.close();
          this.page.pageNum = res.now_page
          this.page.pageTotal = res.total_number
          this.tableData = res.data
        }).catch(() => {
           loading.close();
          this.tableData = []
          this.page.pageTotal = 0
        })

      },
      // 到账
      handleDaoZhang(id) {
        this.$confirm('此操作将到账, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.jgZhuanZhangDaoZhang({
            id: id,
            admin_id: this.user.id,
          }).then(() => {
            this.$message({
              type: 'success',
              message: '成功!'
            });
            this.zhuanZhangList()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      // 拒绝
      handleJuJue(id) {
        this.$prompt('请输入拒绝原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: '',
          inputErrorMessage: ''
        }).then(({value}) => {
          console.log(value)
          if (value == null) {
            this.$message.error("原因不能为空！");
          } else {
            this.$api.apiContent.jgZhuanZhangJuJue({
              id: id,
              message: value,
              admin_id: this.user.id,
            }).then(() => {
              this.$message({
                type: 'success',
                message: '成功!'
              });
              this.zhuanZhangList()
            }).catch(res => {
              this.$message.error(res.info);
            })
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      //  拒绝原因
      handleJuJueYuanYin(id) {
        console.log(id)
        this.$api.apiContent.jgZhuanZhangDetail({
          id: id,
          admin_id: this.user.id,
        }).then(res => {
          console.log(res)
          this.$alert(res.data.message, '拒绝原因', {
            confirmButtonText: '确定',
          });
        }).catch(res => {
          this.$message.error(res.info);
        })
      },
      // 详情弹框
      handleDetail(id) {
        this.dialogVisible = true
        this.$api.apiContent.jgZhuanZhangDetail({
          id: id,
          admin_id: this.user.id,
        }).then(res => {
          this.dataTwo = res.data

        }).catch(res => {
          this.$message.error(res.info);
        })
      },
      // 详情弹框X按钮
      handleClose(done) {
        done();
      },
      handleSizeChange(num){        //  点击分页
        this.page.pageNum = num
      },
      handleCurrentChange(num){     //  选择页数
        this.page.pageNum = num
      },
      keyWord() {     //  搜索
        if(this.page.pageNum === 1){
          this.setPath()
        }else{
          this.page.pageNum = 1
        }
      },
      //  修改路径
      setPath(){
        this.$router.push({
          path:'/home/jgAdmin/jgPay',
          query:{
            pageNum:this.page.pageNum,
            key: this.search,
          }
        })
      },
    },
    watch: {
      'page.pageNum'(){
        this.setPath()
      },
      $route(){
        this.zhuanZhangList()
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .search-box {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    z-index: 1;
    display: flex;
    justify-content: flex-end;


    .search {
      width: 220px;
      position: absolute;
      right: 80px;
      border-radius: 4px !important;
    }
    .btn {
      position: absolute;
      left: 0px;
      padding: 10px 40px;
    }
  }
  .tab-box {
    position: relative;
    /*top: 64px;*/
    /*left: 10px;*/
    /*right: 10px;*/
    /*bottom: 60px;*/
    min-height: 100%;
    padding-top: 50px;
    padding-bottom: 60px;
    background: #fff;


    .page-box{
      position: absolute;
      /*left: 0;*/
      right: 0;
      bottom: 0;
      height: 60px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .el-table th > .cell {
    text-align: center !important;
  }
  .pXq {
    width: 100%;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .Tp1 {
    width: 100%;
    font-size: 14px;
    line-height: 40px;

    .s1 {
      display: inline-block;
      width: 27%;
      text-align: right;
    }

    .s2 {
      display: inline-block;
      min-width: 20%;
      text-align: left;
      margin-left: 20px;
    }
  }
.img {
  width: 80%;
  height: 100px;
  border: 1px solid #000;
  margin-left: 10%;
  margin-top: 40px;
}
</style>